import { normTexts } from "../data/normTexts";
import type { SourceRef } from "../types";

// Zeigt nach der Beantwortung den wörtlichen Gesetzestext zu den Quellen, die einen
// Eintrag in normTexts haben - zum leichteren Einprägen. Quellen ohne Text werden ausgelassen.
export function NormTextList({ sources }: { sources: SourceRef[] }) {
  const withText = sources.filter((source) => normTexts[source.id]);
  if (!withText.length) return null;
  return (
    <div className="norm-text-list">
      {withText.map((source) => (
        <div className="norm-text" key={source.id}>
          <span className="norm-text-label">{source.label} — Wortlaut</span>
          <p>{normTexts[source.id]}</p>
        </div>
      ))}
    </div>
  );
}
